import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import * as api from '../api/global';

const namespace = 'APPEALS';

export const SELECT_APPEAL_RECORD = `${namespace}/SELECT_APPEAL_RECORD`;

export const selectAppealRecord = data => ({
  type: SELECT_APPEAL_RECORD,
  data,
});

export const RESET_ACTIVE_RECORDS = `${namespace}/RESET_ACTIVE_RECORDS`;

export const resetActiveRecords = () => ({
  type: RESET_ACTIVE_RECORDS,
});

export const PREFERENCE_FETCH = createRequestTypes(
  `${namespace}/PREFERENCE_FETCH`,
);

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH[START],
  PREFERENCE_FETCH[SUCCESS],
  PREFERENCE_FETCH[ERROR],
);

export const PREFERENCE_PERSIST = createRequestTypes(
  `${namespace}/PREFERENCE_PERSIST`,
);

export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST[START],
  PREFERENCE_PERSIST[SUCCESS],
  PREFERENCE_PERSIST[ERROR],
);
